<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-card class="elevation-6">
            <v-card-text>
                <v-toolbar color="white" flat>
                    <v-toolbar-title>Απόθεμα Συγγραμμάτων Σημείου Διανομής</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on"
                                   class="mr-2"
                                   icon
                                   color="primary"
                                   href="https://eudoxus.gr/Files/Publisher_Metavoli_Apothematos.pdf"
                                   target="_blank">
                                <v-icon>menu_book</v-icon>
                            </v-btn>
                        </template>
                        <span>Οδηγίες</span>
                    </v-tooltip>
                    <v-speed-dial
                                  class="mb-8"
                                  color="primary" dark fab top right
                                  direction="left"
                                  open-on-hover
                                  v-model="fab">
                        <template v-slot:activator>
                            <v-btn small
                                   color="primary"
                                   dark
                                   fab
                                   v-model="fab">
                                <v-icon v-if="fab">mdi-close</v-icon>
                                <v-icon v-else>settings</v-icon>
                            </v-btn>
                        </template>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on"
                                       color="primary"
                                       @click="openDatePicker(2)"
                                       dark
                                       fab
                                       small>
                                    <v-icon>get_app</v-icon>
                                </v-btn>
                            </template>
                            <span>Αναφορές Συγγραμμάτων Ανά Σημείο Διανομής</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on"
                                       color="primary"
                                       @click="openDatePicker(1)"
                                       dark
                                       fab
                                       small>
                                    <v-icon>system_update_alt</v-icon>
                                </v-btn>
                            </template>
                            <span>Αναφορές Συγγραμμάτων για όλα τα Σημεία Διανομής</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on"
                                       color="primary"
                                       @click="stockUpdateDialog = true"
                                       dark
                                       fab
                                       small>
                                    <v-icon>upload</v-icon>
                                </v-btn>
                            </template>
                            <span>Μαζική ενημέρωση αποθέματος</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on"
                                       color="primary"
                                       @click="exportStockXlsx"
                                       dark
                                       fab
                                       small>
                                    <v-icon>grid_on</v-icon>
                                </v-btn>
                            </template>
                            <span>Εξαγωγή αναλυτικής λίστας αποθέματος (xlsx)</span>
                        </v-tooltip>
                    </v-speed-dial>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-title class="pb-0">

                    <v-row>
                        <v-col cols="1">
                            <v-menu right
                                    v-model="distPointSelectorFilterMenu"
                                    :close-on-content-click="true"
                                    offset-x>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined color="primary" v-on="on">
                                        <v-icon color="primary">mdi-filter-outline</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item-group v-model="selectedDistPointFilter"  color="primary">
                                        <v-list-item
                                                v-for="(item, index) in distPointFilters"
                                                :key="index" :value="item.value">
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-menu>
                        </v-col>
                        <v-col cols="11" lg="5" md="5" sm="11">
                            <v-autocomplete :items="groupedDistPoints"
                                      @change="distPointAvailabilityOnSelectChange"
                                      dense
                                      :item-text="selectorMultiValue"
                                      item-value="id"
                                      :item-disabled="isGroupHeader"
                                      :filter="noFilter"
                                      :search-input.sync="distPointSearch"
                                      label="Σημεία Διανομής"
                                      outlined
                                      return-object
                                      v-model="distPointSelect">
                                <template v-slot:item="{ item, on, attrs }">
                                    <v-list-item v-if="item.isPrefecture" disabled>
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold grey--text text--darken-2">
                                                {{ item.label }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-else-if="item.isCity" disabled class="pl-8">
                                        <v-list-item-content>
                                            <v-list-item-title class="grey--text text--darken-1">
                                                {{ item.label }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-else v-on="on" v-bind="attrs" class="pl-12">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                [{{ item.id }}] {{ item.distributionPointName }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12">
                            <v-select :items="$store.getters.years"
                                      @change="distPointAvailabilityOnSelectChange"
                                      dense
                                      item-text="label"
                                      label="Ακαδημαϊκό Έτος"
                                      outlined
                                      return-object
                                      v-model="academicYearSelect"
                            ></v-select>
                        </v-col>
                    </v-row>

                </v-card-title>

                <v-row>
                    <v-col cols="12" lg="6" md="6" sm="12">
                        <v-text-field
                                append-icon="search"
                                hide-details
                                label="Αναζήτηση"
                                single-line
                                v-model="search"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="$store.getters.distributionAvailability"
                        :search="search"
                        item-key="selectedBookId"
                        no-data-text="Δεν υπάρχουν δεδομένα.">

                    <template v-slot:item="{ item }">

                        <tr>
                            <td class="text-xs-right  d-sm-table-cell d-flex">{{ item.bookId }}</td>
                            <td class="text-center d-sm-table-cell d-flex">{{ item.bookTitle }}</td>
                            <td class="text-center d-sm-table-cell d-flex">{{item.total }}</td>
                            <td class="text-center d-sm-table-cell d-flex">
                                <v-text-field
                                        class="mt-0 pt-0"
                                        hide-details
                                        single-line
                                        style="width: 60px"
                                        type="number"
                                        v-model="item.variation"
                                ></v-text-field>
                            </td>
                            <td class="text-center d-sm-table-cell d-flex">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="upDate(item)"
                                               :disabled="item.variation != 0 ? item.total == 0 && item.variation < 0 ? true : false : true"
                                               class="white--text"
                                               color="#065557"
                                               fab
                                               rounded
                                               small
                                               v-on="on">
                                            <v-icon>done_all</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ενημέρωση</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>

        <div class="text-center">
            <v-dialog persistent
                      max-width="500"
                      v-model="datePicker">
                <v-card flat>
                    <div class="text-center">
                        <v-date-picker :max="maxDate" :min="minDate"
                                       class="elevation-0"
                                       :events="arrayEvents"
                                       full-width
                                       range
                                       color="primary"
                                       first-day-of-week="1"
                                       locale="el"
                                       v-model="dates"></v-date-picker>
                    </div>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn
                                @click="closeDatePicker"
                                color="primary"
                                text>
                            Ακύρωση
                        </v-btn>
                        <v-btn  :loading=" allReport ? $store.getters.amountOfBooksDeliveredForAllDpPdf.isLoading ? true : false : $store.getters.amountOfBooksDeliveredPerDpPdf.isLoading ? true : false"
                                :disabled="dates.length == 0"
                                @click="getReportPdf"
                                color="primary"
                                text>
                            <v-icon>get_app</v-icon>pdf
                        </v-btn>
                        <v-btn  :loading=" allReport ? $store.getters.amountOfBooksDeliveredForAllDpXlsx.isLoading ? true : false : $store.getters.amountOfBooksDeliveredPerDpXlsx.isLoading ? true : false"
                                :disabled="dates.length == 0"
                                @click="getReportXlsx"
                                color="primary"
                                text>
                            <v-icon>get_app</v-icon>xlsx
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog persistent
                      max-width="600"
                      v-model="stockUpdateDialog">
              <v-card flat>
              <v-card-title class="headline primary white--text"
                            primary-title>
                Μαζική ενημέρωση αποθέματος
                <v-spacer></v-spacer>
                <v-icon @click="closeStockUpdateDialog" color="white">close</v-icon>
              </v-card-title>
              <v-card-text>

                <v-file-input
                    clearable
                    class="mt-5"
                    accept=".csv"
                    label="File input"
                    outlined
                    v-model="stockUpdateCsvFile"
                    dense>
                </v-file-input>

              </v-card-text>
              <v-card-actions>
                <v-btn
                        @click="getCsvTemplate"
                        color="primary">
                  Λήψη πρότυπου
                </v-btn><v-spacer/>
                <v-btn
                        @click="uploadStockCsv(stockUpdateCsvFile)"
                        :disabled="stockUpdateCsvFile == null"
                        color="green">
                  Υποβολή
                </v-btn>
                <v-btn
                    @click="closeStockUpdateDialog"
                    color="red">
                  Ακύρωση
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

    </div>
</template>

<script>

    import utils from '../../utilities'
    import request from '../../requests'
    import service from '../../service'
    import {eventBus} from "../../main";
    import stock from "@/components/stock/Stock.vue";

    export default {
        name: "StockArray",
        props:{
            distPoints:Array
        },
        data: () => ({
            utils,
            fab: false,
            distPointSelectorFilterMenu: false,
            distPointFilters: [
                { value:'all', title: 'Όλα' },
                { value:'members', title: 'Με συμμετοχή' },
                { value:'noMembers', title: 'Χωρίς συμμετοχή' },
            ],
            selectedDistPointFilter:'members',
            allReport: false,
            dates: [],
            allDates: [],
            perDpDates: [],
            datePicker: false,
            stockUpdateDialog: false,
            stockUpdateCsvFile: null,
            arrayEvents: [],
            minDate: '',
            maxDate: '',
            years: [],
            distPointSelect: {},
            distPointSearch: null,
            academicYearSelect: {},
            search: '',
            headers: [
                {
                    text: 'Κωδικός',
                    align: 'start',
                    value: 'bookId',
                },
                {text: 'Τίτλος', value: 'bookTitle', align: 'center'},
                {text: 'Διαθεσιμότητα', value: 'total', align: 'center'},
                {text: 'Μεταβολή', value: 'variation', align: 'start'},
                {text: 'Ενημέρωση', value: 'update', align: 'center', sortable: false},
            ],
        }),

        computed:{
          stock() {
            return stock
          },
            filterByActive: function() {
                return this.distPoints.filter((distPoint) => {

                    if (this.selectedDistPointFilter === 'members') {
                        return distPoint.hasMembership;
                    } else if (this.selectedDistPointFilter === 'noMembers') {
                        return !distPoint.hasMembership;
                    } else {
                        return distPoint;
                    }
                });
            },

            // Builds a flat list for the autocomplete, grouped by Prefecture (Νομός)
            // then City (Δήμος). Header rows are non-selectable; distribution points
            // are shown as "[code] NAME". The source list keeps the backend ordering
            // (prefecture name, city name, distribution point name).
            groupedDistPoints: function() {
                let term = (this.distPointSearch || '').toString().trim().toLowerCase();

                // When an item is selected, v-autocomplete pushes its display text into
                // the search field. That is not a user query, so don't let it collapse
                // the list to just the selected item — show everything until the user types.
                const selectedLabel = (this.distPointSelect && this.distPointSelect.id != null && !this.isGroupHeader(this.distPointSelect))
                    ? this.selectorMultiValue(this.distPointSelect).toLowerCase()
                    : '';
                if (term && term === selectedLabel) {
                    term = '';
                }

                const dps = this.filterByActive.filter((dp) => {
                    if (!term) {
                        return true;
                    }
                    const label = ('[' + dp.id + '] ' + (dp.distributionPointName || '')).toLowerCase();
                    return label.indexOf(term) !== -1;
                });

                const result = [];
                let lastPrefecture = null;
                let lastCity = null;

                dps.forEach((dp) => {
                    if (dp.prefectureName !== lastPrefecture) {
                        lastPrefecture = dp.prefectureName;
                        lastCity = null;
                        result.push({
                            id: 'pref-' + (dp.prefectureId != null ? dp.prefectureId : dp.prefectureName),
                            isPrefecture: true,
                            label: dp.prefectureName
                        });
                    }
                    if (dp.cityName !== lastCity) {
                        lastCity = dp.cityName;
                        result.push({
                            id: 'city-' + (dp.cityId != null ? dp.cityId : dp.cityName),
                            isCity: true,
                            label: dp.cityName
                        });
                    }
                    result.push(dp);
                });

                return result;
            }
        },

        methods: {


            selectorMultiValue(item){

                if (item.isPrefecture || item.isCity) {
                    return item.label
                }
                return '[' + item.id + '] ' + item.distributionPointName
            },

            // Prefecture / city rows are group headers, not selectable options.
            isGroupHeader(item){
                return !!(item.isPrefecture || item.isCity)
            },

            // Search filtering is handled in the groupedDistPoints computed so that
            // group headers stay attached to their items; disable the built-in filter.
            noFilter(){
                return true
            },


            upDate(book) {

                var bookAvailabilityObject = {
                    bookId: book.bookId,
                    distributionPointId: book.distributionPointId,
                    year: this.academicYearSelect.value,
                    totalIncrement: book.variation
                };

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.upDateDistributionPoint(token, bookAvailabilityObject, this.upDateDistributionPointCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }

            },

            upDateDistributionPointCallBack(response) {
                this.$store.commit('setDistributionAvailability', this.createDynamicModel(response));
                this.$store.commit('setLoadingModal', false);
            },

            //get report by date and dist Point
            getReportPdf() {

                if (this.allReport) {
                //    get all Reports
                    this.allDates = utils.sortDatesArray(this.dates);
                    service.startServiceAmountOfBooksDeliveredForAllDpPdf(this.allDates);
                }
                else {
                //    get report from dist Point
                    this.perDpDates = utils.sortDatesArray(this.dates);
                    service.startServiceAmountOfBooksDeliveredPerDpPdf(this.perDpDates, this.distPointSelect);
                }
            },

            getReportXlsx() {
                if (this.allReport) {
                    //    get all Reports
                    this.allDates = utils.sortDatesArray(this.dates);
                    service.startServiceAmountOfBooksDeliveredForAllDpXlsx(this.allDates);
                }
                else {
                    //    get report from dist Point
                    this.perDpDates = utils.sortDatesArray(this.dates);
                    service.startServiceAmountOfBooksDeliveredPerDpXlsx(this.perDpDates, this.distPointSelect);
                }
            },

            // Export the analytical stock list (selected books + matched distribution points)
            // for the currently selected academic year as an .xlsx file.
            exportStockXlsx() {
              let token = utils.getLocalStorage('token');
              if (token != null) {
                this.$store.commit('setLoadingModal', true);
                request.getStockExportXlsx(token, this.academicYearSelect.value, () => {
                  this.$store.commit('setLoadingModal', false);
                });
              } else {
                this.$store.commit('setloginModal', true);
              }
            },

            getCsvTemplate() {
              let token = utils.getLocalStorage('token');
              if (token != null) {
                this.$store.commit('setLoadingModal', true);
                request.getStockCsvTemplate(token, (response) => {this.$store.commit('setLoadingModal', false);});
              }
            },

            getCsvErrors() {
              let token = utils.getLocalStorage('token');
              if (token != null) {
                this.$store.commit('setLoadingModal', true);
                request.getStockCsvErrors(token, (response) => {
                  this.$store.commit('setLoadingModal', false);
                  utils.setErrorPopup('Βρέθηκαν προβλήματα στο αρχείο. Κατέβηκε αρχείο με παρατηρήσεις.')
                });
              }
            },

            uploadStockCsv(file) {
              let token = utils.getLocalStorage('token');
              if (token != null) {
                this.$store.commit('setLoadingModal', true);
                const formData = new FormData();
                formData.set('file', file);
                request.uploadStockCsv(token, formData, this.uploadStockCsvCallback, this.getCsvErrors);
              }
            },

            uploadStockCsvCallback(response) {
              this.closeStockUpdateDialog();
              this.$store.commit('setLoadingModal', false);
              utils.setSuccessPopup('Η ενημέρωση πραγματοποιήθηκε επιτυχώς');
            },

            openDatePicker(selectedBookId){

                this.maxDate = utils.createPickerCurrentDate();

                if(selectedBookId == 1){
                    this.dates = this.allDates;
                    this.allReport = true;
                }else{
                    this.dates = this.perDpDates;
                    this.allReport = false;
                }
                this.datePicker = true;
            },

            closeDatePicker(){

                this.dates = [];
                this.allReport = null;
                console.warn(this.allReport);
                this.datePicker = false;
            },

            closeStockUpdateDialog() {
              this.stockUpdateDialog = false;
              this.stockUpdateCsvFile = null;
            },

            //    create dynamic v-model in response obj (pass variation var)
            createDynamicModel(book) {

                for (var i = 0; i < book.length; i++) {
                    book[i].variation = 0
                }
                return book;
            },

            //    function to request distribution-point-availability
            distPointAvailabilityOnSelectChange() {

                var distributionPointId = this.distPointSelect.id;
                var year = this.academicYearSelect.value;

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getdistributionPointAvailability(token, distributionPointId, year, this.getdistributionPointAvailabilityCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getdistributionPointAvailabilityCallBack(response) {

                this.$store.commit('setDistributionAvailability', this.createDynamicModel(response));
                this.$store.commit('setLoadingModal', false);
            },

            createSelectedVariables() {

                var distPointSelected = this.distPoints;
                var years = this.$store.getters.years;

                if (years.length > 0) {
                    this.academicYearSelect = years[0];
                }

                if (distPointSelected.length > 0) {
                    this.distPointSelect = distPointSelected[0];
                }
            },

        },

        watch: {
            'selectedDistPointFilter': function (val) {
                console.log(val);
            },
        },
        created() {
                eventBus.$on('createSelectedVariables', () => {
                this.createSelectedVariables();
            });
        },
        beforeDestroy() {
            eventBus.$off('createSelectedVariables');
        }
    }
</script>

<style scoped>

</style>